import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { set } from '@ember/object';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { CLASSIFICATION_TYPES, CLASSIFICATION_CATEGORIES } from 'sh-www/models/classification';
import { USER } from 'sh-www/models/user';

const include = [
  'projectdigests.application.buyer',
  'projectdigests',
  'projectdigests.image',
  'projectdigests.projectdigest-verifications:verified_or_latest',
  'projectdigests.review.reviewer',
  'projectdigests.services',
  'projectdigests.video-topics',
  'projectdigests.video-category',
  'projectdigests.company',
  'projectdigests.classifications',
].join(',');

/** @module */
const CreatorSignupWorkRoute = Route.extend({
  classificationCommandService: service('commands.classification-commands'),
  session: service(),
  store: service(),

  /** @inheritDoc */
  model() {
    const availableServices = this.store.findAll('service', {
      include: 'service-synonyms',
      adapterOptions: {
        isPublic : true,
      },
    });

    const availableClassifications = this.classificationCommandService.loadClassifications({
      filters: {
        types: [
          CLASSIFICATION_TYPES.TYPE_DEFAULT,
        ],
        categories: [
          CLASSIFICATION_CATEGORIES.CATEGORY_SUBJECT,
          CLASSIFICATION_CATEGORIES.CATEGORY_INDUSTRY,
        ],
      },
    });

    const user = this.store.findRecord('user', this.get('session.currentUser.id'), {
      include,
    });

    return Promise.all([availableServices, availableClassifications, user]).then(([availableServices, availableClassifications, user]) => ({
      availableServices,
      availableClassifications,
      user,
      profile: user.profile,
    }));
  },

  activate(transition) {
    this._super(...arguments);

    set(
      this.controllerFor('signup.step'),
      'signupStep',
      USER.SELLER_SIGNUP_STEPS.WORK_SAMPLES,
    );

    trackPageViewFromTransition(this, transition, '/signup/step/work/');
  },
});

export default CreatorSignupWorkRoute;
